var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPassword = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none",
    id: "Icon-/-Events-/-Status-/-Background"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.11110919713974,18.014564514160156 17.111099660396576,18.014564514160156 17.111099660396576,9.666656494140625 5.11110919713974,9.666656494140625 ",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m8.11111,10.13155l0,-3.43908c0,-1.6712 1.34335,-3.0258 2.99981,-3.0258c1.65723,0 3.00019,1.3546 3.00019,3.0258l0,3.43908"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPassword, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Password.730fd1b6.svg";
export { ForwardRef as ReactComponent };